var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43564"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2342",
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#B8091C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5852 15.0018C19.8857 15.0182 19.2236 15.2725 18.7196 15.776L16.2756 18.2255C15.1268 19.3734 15.2717 21.3667 16.596 22.6928L23.8946 30.0018L16.596 37.3077C15.2717 38.6334 15.1263 40.6271 16.2756 41.7773L18.7196 44.2249C19.8684 45.3724 21.858 45.2297 23.1841 43.9036L30.4827 36.5955L37.7813 43.9036C39.1083 45.2297 41.0993 45.3724 42.2459 44.2249L44.6935 41.7773C45.84 40.6276 45.6974 38.6338 44.3704 37.3077L37.0718 30.0018L44.3704 22.6928C45.6974 21.3667 45.84 19.3734 44.6935 18.2255L42.2459 15.776C41.0993 14.6258 39.1083 14.7712 37.7813 16.0991L30.4827 23.4055L23.1841 16.0996C22.4391 15.3513 21.4825 14.9799 20.5852 15.0018Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejectedIcon.a40a1caf314743a9a646dfd90c355904.svg";
export { ForwardRef as ReactComponent };